(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@fiizy/fitch", [], factory);
	else if(typeof exports === 'object')
		exports["@fiizy/fitch"] = factory();
	else
		root["@fiizy/fitch"] = factory();
})(self, () => {
return 